/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "model": {
            "nested": {
              "SqInstallmentPlan": {
                "fields": {
                  "applicationFlowToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "selectedOfferToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "planToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.model?.nested?.SqInstallmentPlan) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE SqInstallmentPlan @ squareup/solidshop/model/sq_installment_plan.proto at 8:1
 */
export const SqInstallmentPlan = $root.lookupType('squareup.solidshop.model.SqInstallmentPlan');
fixType(SqInstallmentPlan);
Builder.createAndAttachToType(SqInstallmentPlan);
